import React, { useContext } from 'react';
import { useLoaderData, Link, redirect, Outlet } from 'react-router-dom';
import { ContentFrame } from '../../components/content_frame/content_frame';
import { DefaultSubSectionTitle } from '../../components/default_section/default_section';
import { AuthContext } from '../../contexts';
import { getModels, setUrlParameters } from '../../utils/functions';
import { 
  DESKTOP_PATH, 
  LOGIN_PATH, 
  COMPLAINT_CASE_EDIT_PATH,
  DESKTOP_ARCHIVE_COMPLAINT_CASE_PATH } from '../../constants/paths';
import { COMPLAINT_CASES_GET_API } from '../../constants/apis';
import { VIEW_BASIC_COMPLAINT_CASE_PERMISSION } from '../../constants/permissions';
import { COMPLAINT_CASE_STATUS_OPTIONS } from '../../constants/constants';
import './desktop.scss';


export async function desktopLoader() {  
  try {
    return await getModels(setUrlParameters(COMPLAINT_CASES_GET_API, {
      has_finished: false,
      load_clinic_name: true,
      load_patient_name: true
    }));
  }
  catch(errors) {
    if(errors instanceof Array) {
      for(let error of errors) {
        if(error.code === 209) {
          // Expired user session
          return redirect(LOGIN_PATH);
        }
        else if(error.code === 203) {
          // Not authorized
          return [];
        }
      }
    }

    throw errors;    
  }
};

class Desktop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      screenWidth: window.innerWidth,
    };
  }

  async componentDidMount() {
    this.resizeListener = () => this.updateSize();

    window.addEventListener("resize", this.resizeListener);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeListener);
  }

  updateSize() {
    this.setState({
      screenWidth: window.innerWidth
    });
  }

  getTodayDate() {
    let dateString = (new Intl.DateTimeFormat('pt-BR', {
      weekday: this.state.screenWidth > 510 ? 'long' : 'short',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })).format(new Date());

    dateString = dateString[0].toLocaleUpperCase() + dateString.slice(1);

    return (
      <h4 className="desktop__today-text">

        {dateString}

      </h4>
    );
  }

  getComplaintCases() {
    const caseElements = this.props.complaint_cases.map((entry) => {
      return (
        <li
          key={`complaint_case:${entry.id}`}
          className="desktop__complaint-cases__case__wrapper"
        >

          <div className={`desktop__complaint-cases__case__priority-indicator--${entry.statusIndex}`}></div>

          <div className="desktop__complaint-cases__case">

            <div className="desktop__complaint-cases__case__main">

              <h3 className="desktop__complaint-cases__case__label">{entry.clinic_name}/{entry.patient_name}</h3>

            </div>

            <div className="desktop__complaint-cases__case__status">

              <p className={`desktop__complaint-cases__case__status__text--${entry.statusIndex}`}>{COMPLAINT_CASE_STATUS_OPTIONS[entry.statusIndex]}</p>

            </div>

            <div className="desktop__complaint-cases__case__actions">
            
              <Link
                className="model-table__default-edit-button desktop__complaint-cases__case__actions__link-button"
                to={`${COMPLAINT_CASE_EDIT_PATH}${entry.id}`}
              >

                  <i className="fa-solid fa-eye"></i>

              </Link>

              <Link
                className="model-table__default-delete-button"
                to={`${DESKTOP_ARCHIVE_COMPLAINT_CASE_PATH.slice(1)}${entry.id}`}
              >

                  <i className="fa-solid fa-box"></i>

              </Link>

            </div>

          </div>

        </li>
      );
    });

    return (
      <ul className="desktop__complaint-cases">

        <li className="desktop__complaint-cases__header">

          <p className="desktop__complaint-cases__header__name">Clínica/Paciente</p>
          <p className="desktop__complaint-cases__header__status">Situação</p>
          <p className="desktop__complaint-cases__header__actions">Ações</p>

        </li>

        {caseElements.length <= 0 &&
          <li className="desktop__complaint-cases__no-data-found">
            <p className="desktop__complaint-cases__no-data-found__text">Nenhum caso aberto</p>
          </li>
        }

        {caseElements}

      </ul>
    );
  }

  render() {
    return (
      <>
      
        <Outlet />

        <ContentFrame
          headerHistory={[
            {
              path: DESKTOP_PATH,
              text: "Área de trabalho"
            },
          ]}
          titleIcon={<i className="fas fa-home"></i>}
          title="Área de trabalho"
        >
          <div className="desktop__wrapper">

            {this.getTodayDate()}

            {this.props.auth.permission_ids.includes(VIEW_BASIC_COMPLAINT_CASE_PERMISSION) &&
              <>

                <DefaultSubSectionTitle
                  icon={<i className="fa-solid fa-scale-balanced"></i>}
                  text="Casos abertos"
                />

                {this.getComplaintCases()}
                
              </>
            }

          </div>

        </ContentFrame>

      </>
    );
  }
}

const WrappedDesktop = props => {
  const complaint_cases = useLoaderData();
  const auth = useContext(AuthContext);

  complaint_cases.forEach((entry) => {
    let index = 0;
  
    if (entry.has_finished) {
      index = entry.form_filled ? 0 : 1;
    }
    else {
      index = entry.form_filled ? 2 : 3;
    }
    
    entry.statusIndex = index;
  });
  complaint_cases.sort((a, b) => {
    if (a.statusIndex === b.statusIndex) {
      return b.id - a.id; // Older entries comes first
    }
    
    return a.statusIndex - b.statusIndex;
  });

  return (
    <Desktop
      complaint_cases={complaint_cases}
      auth={auth}
      {...props}
    />
  );
};

export {WrappedDesktop as Desktop};
